<template>
  <Modal
    :show="show"
    width="366"
    cancel-text=""
    action-text=""
    @close="$emit('close')"
  >
    <template #title>
      <span class="text-h2">Remove from Job Family</span>
    </template>
    <template #content>
      <p class="text-body-1 text-textDarkest mb-0">
        {{ bodyLine }}
      </p>
    </template>
    <template #actions>
      <DpplNewButton
        class="bulk-modal-action text-button-1"
        variant="flat"
        color="primary"
        :loading="loading"
        @click="$emit('confirm')"
      >
        Remove
      </DpplNewButton>
    </template>
  </Modal>
</template>

<script setup>
import { computed } from 'vue';
import Modal from '@/components/shared/Modal.vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';
import { formatFamilyUsage } from '@/components/jobArchitecture/helpers';

const props = defineProps({
  show: { type: Boolean, default: false },
  count: { type: Number, default: 0 },
  draftCount: { type: Number, default: 0 },
  familyScope: { type: String, default: '' },
  loading: { type: Boolean, default: false },
});

defineEmits(['close', 'confirm']);

const bodyLine = computed(() => {
  const usage = formatFamilyUsage({
    profileCount: props.count,
    draftCount: props.draftCount,
  });
  const scope = props.familyScope || 'the selected job families';
  const removePart = usage ? `Remove ${usage} from` : 'Remove from';

  return `${removePart} ${scope}. They'll appear under Uncategorized until reassigned.`;
});
</script>

<style scoped lang="less">
.bulk-modal-action {
  margin-top: 34px;
  width: 150px;
  height: 40px !important;
  min-height: 40px !important;
}
</style>
